import React, { useEffect, useRef, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import PropTypes from "prop-types"
import axios from 'axios';
import { useDidMountEffect } from 'src/helpers/functions';
// import handleErrors from 'src/helpers/handleErrors';

let mySingleAutocompleteListCache = [];

const SingleCustomAutocompleteServerSide = props => {
    const filedName = props.filedName;
    const fieldLabel = props.label;
    const fieldValue = props.value;
    const listKey = props.listKey;
    const listDescription = props.description;
    const customOnChange = props.customOnChange;
    const cacheSavedData = props.cacheSavedData === true;
    const [list, setList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoading2, setIsLoading2] = useState(false);
    const previousController = useRef();
    const previousController2 = useRef();
    const [currValue, setCurrValue] = useState(null);
    const [currDesc, setCurrDesc] = useState(null);

    const getData = async (searchTerm, source) => {
        return new Promise((resolve, reject) => {
            setIsLoading(true)
            axios.get(`${process.env.REACT_APP_API}${props.apiEndPoint}`, {
                params: {
                    searchQuery: JSON.stringify({
                        q: searchTerm,
                        selectedValues: fieldValue ? [fieldValue] : [],
                    })
                },
                cancelToken: source.token,
            })
                .then(function (response) {
                    if (cacheSavedData) {
                        mySingleAutocompleteListCache[`${props.apiEndPoint}-${fieldValue}`] = response.data;
                    }
                    setList(response.data);
                    setIsLoading(false)
                    resolve();

                })
                .catch(function (error) {
                    // Don't treat cancellation as an error
                    if (axios.isCancel(error)) {
                        setIsLoading(false)
                        resolve();
                        return;
                    }
                    // handleErrors(error);
                    setIsLoading(false)
                    reject(error)
                })
        })
    };

    const onInputChange = (event) => {
        const value = event.target.value
        if (value) {
            let source = previousController.current;
            source?.cancel("cancelled_cleanup");
            source = previousController.current = axios.CancelToken.source();
            if (previousController2.current) {
                clearTimeout(previousController2.current)
            }

            previousController2.current = setTimeout(() => {
                if (!isLoading) {
                    getData(value, source);
                }

            }, 150)
        }
    };

    useEffect(() => {
        const source = axios.CancelToken.source();
        let tempList = [];
        if (cacheSavedData === true && list.length === 0) {
            tempList = mySingleAutocompleteListCache[`${props.apiEndPoint}-${fieldValue}`] ? mySingleAutocompleteListCache[`${props.apiEndPoint}-${fieldValue}`] : []
            setList(tempList);
        }
        else {
            tempList = list;
        }
        async function fetchData(source, list, fieldValue) {
            if (fieldValue) {
                let fetchData = true;
                list.forEach(element2 => {
                    if (element2[listKey] == fieldValue) {
                        fetchData = false;
                    }
                });
                if (fetchData) {
                    setIsLoading2(true);
                    try {
                        await getData("", source);
                    } catch (error) {
                        // Ignore cancellation errors
                        if (!axios.isCancel(error)) {
                            console.error('Error fetching data:', error);
                        }
                    } finally {
                        setIsLoading2(false);
                    }
                }
            }
        }
        fetchData(source, tempList, fieldValue);
        setCurrValue(fieldValue)
        return function () {
            source.cancel("cancelled_cleanup");
        };
    }, [fieldValue])

    const optionForLabel = (label) => {
        if (typeof label === 'object' &&
            !Array.isArray(label) &&
            label !== null) {
            return `${label[listDescription]}`
        }
        let toReturn = list.find(
            (source) => { return source[listKey] == label }
        )
        if (toReturn) {
            return `${toReturn[listDescription]}`
        }
        return `${label}`
    }

    const update = (event, value) => {
        if (value === null) {
            setCurrValue(null);
            setCurrDesc(null);
            if (customOnChange) {
                customOnChange(null, filedName, event);
            }
            return;
        } else {
            setCurrValue(value[listKey]);
            setCurrDesc(value[listDescription]);
            if (customOnChange) {
                customOnChange(value[listKey], filedName, value[listDescription], value, event);
            }
        }
    }

    const onFocus = () => {
        const source = axios.CancelToken.source();
        if (!fieldValue && list.length === 0) {
            getData("", source).catch(error => {
                // Ignore cancellation errors
                if (!axios.isCancel(error)) {
                    console.error('Error fetching data:', error);
                }
            });
        }
        return function () {
            source.cancel("cancelled_cleanup");
        };
    }

    useDidMountEffect(() => {
        setList([])
    }, [props.apiEndPoint])

    return (
        <FormControl style={{ width: "100%" }}>
            {isLoading2 ? (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '20px',
                    width: '100%'
                }}>
                    <div style={{
                        width: '20px',
                        height: '20px',
                        border: '2px solid #f3f3f3',
                        borderTop: '2px solid #007bff',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                    }}></div>
                    <style>{`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `}</style>
                </div>
            ) : (
                <Autocomplete
                    disablePortal
                    disabled={props.disabled ? props.disabled : false}
                    onFocus={onFocus}
                    name={filedName}
                    options={isLoading ? [] : list} // Options List
                    value={customOnChange ? fieldValue : currValue}
                    onChange={update}
                    getOptionLabel={optionForLabel}
                    isOptionEqualToValue={(option, value) => {
                        return value == option[listKey]
                    }}
                    loading={isLoading}
                    style={{ width: "100%" }}
                    groupBy={props.groupBy ? (option) => option[props.groupBy] : null}
                    renderInput={(params) => <TextField {...params} label={fieldLabel} onChange={onInputChange} />}
                />
            )}
            {currValue ? <input type="hidden" name={filedName} value={currValue} /> : null}
            {currDesc ? <input type="hidden" name={`${filedName}Desc`} value={currDesc} /> : null}

        </FormControl>
    );
}

SingleCustomAutocompleteServerSide.propTypes = {
    filedName: PropTypes.any.isRequired,
    value: PropTypes.any,
    listKey: PropTypes.any.isRequired,
    description: PropTypes.any.isRequired,
    customOnChange: PropTypes.any,
    disabled: PropTypes.any,
    groupBy: PropTypes.any,
    isLoading: PropTypes.bool,
    apiEndPoint: PropTypes.any.isRequired,

}

export default SingleCustomAutocompleteServerSide;